// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanScheduledContributionDto
 */
export interface IPlanScheduledContributionDto {
    /**
     * 
     * @type {number}
     * @memberof IPlanScheduledContributionDto
     */
    plan_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPlanScheduledContributionDto
     */
    plan_code?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanScheduledContributionDto
     */
    plan_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IPlanScheduledContributionDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanScheduledContributionDto
     */
    per_pay_employee?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanScheduledContributionDto
     */
    per_pay_employer?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanScheduledContributionDto
     */
    contribution_monitoring_required?: boolean;
}

/**
 * Check if a given object implements the IPlanScheduledContributionDto interface.
 */
export function instanceOfIPlanScheduledContributionDto(value: object): value is IPlanScheduledContributionDto {
    return true;
}

export function IPlanScheduledContributionDtoFromJSON(json: any): IPlanScheduledContributionDto {
    return IPlanScheduledContributionDtoFromJSONTyped(json, false);
}

export function IPlanScheduledContributionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanScheduledContributionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'per_pay_employee': json['per_pay_employee'] == null ? undefined : json['per_pay_employee'],
        'per_pay_employer': json['per_pay_employer'] == null ? undefined : json['per_pay_employer'],
        'contribution_monitoring_required': json['contribution_monitoring_required'] == null ? undefined : json['contribution_monitoring_required'],
    };
}

export function IPlanScheduledContributionDtoToJSON(json: any): IPlanScheduledContributionDto {
    return IPlanScheduledContributionDtoToJSONTyped(json, false);
}

export function IPlanScheduledContributionDtoToJSONTyped(value?: IPlanScheduledContributionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_id': value['plan_id'],
        'plan_code': value['plan_code'],
        'plan_name': value['plan_name'],
        'employee_id': value['employee_id'],
        'per_pay_employee': value['per_pay_employee'],
        'per_pay_employer': value['per_pay_employer'],
        'contribution_monitoring_required': value['contribution_monitoring_required'],
    };
}

